import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const Debts = () => {
    document.title = "Borclar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Maliyyə", value: "/finance" },
        { name: "Borclar", value: "/finance/debts" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Borclar</h2>
                    <p>
                        Borclar səhifəsi sahibkarın <mark>alacaq</mark> və <mark>verəcək</mark> borclarının göstəricisidir. Müştərinin borcunun necə
                        formalaşması tarixçəsinə <b>üzləşmə aktı</b> ilə baxmaq olar. Tərəf müqabil (kontragent) adının üstünə tıklasaq, həmin tərəf müqabil ilə{" "}
                        <mark>ümumi borcun</mark> formalaşmasına səbəb olan bütün əməliyyatlar istifadəçiyə təqdim olunacaq. ( Üzləşmə aktı ) . Həmçinin üzləşmə
                        aktını <Button>Çap</Button> edib və ya endirib müştəriyə təqdim etmək olar.
                        <br />
                        Nümunədə Maliyyə ⮞ Borclar ⮞ Üzləşmə aktı səhifəsinə keçid göstərilib.
                    </p>
                    <img src="/images/finance/debts.gif" alt="Borclar" />
                </article>
            </div>
        </div>
    );
};
